module.exports = __webpack_public_path__ + "img/tip.png";